export default __webpack_public_path__ + "static/media/3.ded11d27.jpg";